import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=66f5a2c7&"
import script from "./Privacy.vue?vue&type=script&lang=js&"
export * from "./Privacy.vue?vue&type=script&lang=js&"
import style0 from "./Privacy.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports